import { createSlice } from "@reduxjs/toolkit";

const sessionInitState = {
  isLoading: false,
  sessions: [],
  session: {},
  sessionsSchedule:[],
};
const sessionReducerSlice = createSlice({
  name: "session",
  initialState: sessionInitState,
  reducers: {
    changeSessionLoading: (state, action) => {
      if (state.isLoading !== action.payload) {
        state.isLoading = action.payload;
      }
    },
    addSessionState: (state, action) => {
      state.sessions.unshift(action.payload);
      state.isLoading = false;
    },
    setDuplicateSessions: (state, action) => {
      // state.sessions.unshift(action.payload);
      state.sessions = [...action.payload, ...state.sessions];

      state.isLoading = false;
    },
    setSessionById: (state, action) => {
      state.session = action.payload;
      state.isLoading = false;
    },
    setSessionState: (state, action) => {
      state.sessions = action.payload.sessions || state.sessions;
      state.isLoading = false;
    },
    setSessionScheduleState: (state, action) => {
      state.sessionsSchedule = action.payload.sessionsSchedule || state.sessionsSchedule;
      state.isLoading = false;
    },
    editSessionState: (state, action) => {
      state.sessions = state.sessions.map((session) => {
        if (action.payload._id === session._id) {
          session = action.payload;
        }
        return session;
      });
      state.isLoading = false;
    },
    deleteSessionState: (state, action) => {
      state.sessions = state.sessions.filter(
        (session) => session._id !== action.payload
      );
      state.isLoading = false;
    },
  },
});

export const {
  changeSessionLoading,
  addSessionState,
  setSessionState,
  setSessionById,
  deleteSessionState,
  editSessionState,
  setDuplicateSessions,setSessionScheduleState
} = sessionReducerSlice.actions;

export default sessionReducerSlice.reducer;
